import ActionTypes from 'app/action-types';
import * as Sentry from '@sentry/browser';
import navigateTo from 'shared/helpers/navigate-to';
import * as Auth0 from 'shared/helpers/auth0';

const getLocalRedirectPath = url => {
  if (!url) {
    return '/';
  }

  return url
    .split('/')
    .slice(3)
    .join('/');
};

const safelyParseJson = string => {
  try {
    return JSON.parse(string);
  } catch (error) {
    return undefined;
  }
};

const decodeDataUri = base64String => safelyParseJson(atob(base64String));

const parseToken = params => {
  if (params && params.token) {
    return new Promise(resolve => {
      const { token, userId, expires, redirect } = decodeDataUri(params.token) || {};

      return resolve({ token, userId, expires, redirect });
    });
  }

  return Auth0.parseHash();
};

const isTokenValid = (token = {}) => {
  const expires = parseFloat(token.expires);

  return (
    typeof token.token === 'string' &&
    token.token.length > 0 &&
    typeof token.userId === 'string' &&
    token.userId.length > 0 &&
    !isNaN(expires) &&
    expires > Date.now()
  );
};

export default params => dispatch => {
  return parseToken(params).then(({ redirect, ...token }) => {
    if (isTokenValid(token)) {
      dispatch({
        type: ActionTypes.USER_LOGIN_SUCCESS,
        result: token,
      });
      return navigateTo(getLocalRedirectPath(redirect));
    }

    const error = new TypeError('Invalid token signature');
    Sentry.captureException(error);

    return dispatch({
      type: ActionTypes.USER_LOGIN_FAIL,
      error,
    });
  });
};
